import GroupList from './GroupList';
import GroupCreate from './GroupCreate';
import GroupEdit from './GroupEdit';
import GroupIcon from '@material-ui/icons/Security';

export default {
  list: GroupList,
  create: GroupCreate,
  edit: GroupEdit,
  icon: GroupIcon
};
